export default {
  SET_SALTO_SHIP_ROOM_LIST_LOADING(state, loading) {
    state.saltoShipRoomListLoading = loading;
  },
  SET_SALTO_SHIP_ROOM_LIST(state, payload) {
    state.saltoShipRoomList = payload;
    state.saltoShipRoomListError = null;
  },
  SET_SALTO_SHIP_ROOM_LIST_ERROR(state, error) {
    state.saltoShipRoomList = null;
    state.saltoShipRoomListError = error;
  },
};
